import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const ActionButtons = ({ onRetry, showRetry = true, showContinue = true }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col sm:flex-row gap-3">
      {showRetry && (
        <Button
          variant="outline"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onRetry}
          fullWidth
        >
          Try Again
        </Button>
      )}
      
      {showContinue && (
        <Button
          variant="default"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={() => navigate('/app/dashboard')}
          fullWidth
        >
          Back to Dashboard
        </Button>
      )}

      <Button
        variant="secondary"
        iconName="Shield"
        iconPosition="left"
        onClick={() => navigate('/objection-dojo')}
        fullWidth
      >
        Practice Objections
      </Button>
    </div>
  );
};

export default ActionButtons;